import { Button, intl } from 'ehs-react';
import React from 'react';

export function SecondaryBackButton({
  onBackClicked
}: Readonly<{
  onBackClicked: () => void;
}>): JSX.Element {
  return (
    <div className="content-button-bar secondary">
      <Button
        scale={'medium'}
        onClick={onBackClicked}
        text={intl('view.button.back')}
        variant="gray"
      />
    </div>
  );
}
